import { Box } from "@mui/material";

const TabContainorQuestions = ({editableMultimediaData, setEditableMultimediaData, multimediaData, setMultimediaData, showLoader, global_constant}) => {
        return (
            <Box sx={{p:2}}>
                {/* <Typography fontWeight="bold" sx={{ fontSize: 14, color: 'green' }}>
                    Multimedia Content Here
                </Typography> */}

                {/* <MultimediaPanelView editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} global_constant={global_constant}/> */}
            </Box>
        );
    }

    export default TabContainorQuestions;